import {
  canEditPlanUtil as canEditPlanUtilGA,
  isAdminProfileUtil
} from '@gymaholic/packages'

export default function canEditPlanUtil (plan, profile) {
  return (
    canEditPlanUtilGA(plan, profile) ||
    isAdminProfileUtil(profile)
  )
}
